module.exports = __webpack_public_path__ + "static/media/help.6ceaf8f0.svg";